import ICustomError from "../../types/ICustomError";
import awsCognito from "../../../app/security/awsCognito";
import globalStore from "../../../app/stores/globalStore";
import { routeFns } from "../../../app/router/routes";
import router from "../../../app/router";
import securityModule from "../../../app/security/SecurityModule";

export class TvdWelcomeElement extends HTMLElement {
  public static observedAttributes = [];

  constructor() {
    super();
  }

  connectedCallback() {
    if (securityModule.isLoggedIn) {
      const effectiveOrgs = awsCognito.allEffectiveOrganizationsInfo;

      if (effectiveOrgs.length > 0) {
        router.navigate(routeFns.myCloud());
      } else {
        if (!globalStore.messageNoOrgsHasBeenShown) {
          document.body.dispatchEvent(
            new CustomEvent<ICustomError>("customError", {
              detail: {
                message: "Your user is not enabled in any organization.",
                translationKey: "errors:USER_DISABLED",
                errorCode: "USER_DISABLED",
              },
            }),
          );
          globalStore.messageNoOrgsHasBeenShown = true;
        }
        router.navigate(routeFns.myProfile());
      }
    } else {
      router.navigate(routeFns.login(), undefined, true);
    }
  }
}

customElements.define("tvd-welcome-component", TvdWelcomeElement);

declare global {
  interface HTMLElementTagNameMap {
    "tvd-welcome-component": TvdWelcomeElement;
  }
}
